export default __webpack_public_path__ + "static/media/03__o_preview_3.d2aef5d5.jpg";